<template>
   <div class="option-selector">
      <div class="option-selector-options">
         <div class="option-item" v-for="(option, index) in options" :key="index" @click="handleSelectOption(option)" :class="{ selected: selectedValue === option.value }">
            <div class="option-item-wrapper">
               <i v-if="showIcon && option.icon" class="flag-icon" :class="'flag-icon-' + option.icon"></i>
               <span>{{ option.name }} </span>
            </div>
            <div class="stars-view" v-if="showStars && option.value !== 'all' && option.value !== '-1'">
               <i v-for="star in 5" :key="star" class="gts-icon icon-star" :class="{ active: star <= option.value }"> </i>
            </div>
         </div>
      </div>
   </div>
</template>

<script>
export default {
   name: "OptionSelector",
   props: {
      options: {
         type: Array,
         required: true,
      },
      value: {
         type: String,
         default: "",
      },
      showIcon: {
         type: Boolean,
         default: false,
      },
      showStars: {
         type: Boolean,
         default: false,
      },
   },
   data() {
      return {
         selectedValue: this.value,
      };
   },
   methods: {
      handleSelectOption(option) {
         this.selectedValue = option.value;
         this.$emit("input", option.value);
         this.$emit("update-selection", option);
         this.$emit("close");
      },
   },
   watch: {
      value: {
         handler(newValue) {
            this.selectedValue = newValue;
         },
         immediate: true,
      },
   },
};
</script>

<style lang="scss" scoped>
.stars-view {
   display: flex;
   .gts-icon {
      width: 15px !important;
      opacity: 0.2;

      &.active {
         opacity: 1;
         filter: invert(74%) sepia(100%) saturate(805%) hue-rotate(358deg) brightness(103%) contrast(103%);
      }
   }
}

.option-selector {
   width: 100%;
   background-color: var(--container-bg);
   border-radius: 0.5rem;
   box-shadow: var(--gts-box-shadow);

   .option-selector-options {
      max-height: 300px;
      overflow-y: auto;
      padding: 0.5rem 0;

      .option-item {
         display: flex;
         align-items: center;
         justify-content: space-between;
         padding: 0.5rem 1rem;
         cursor: pointer;
         color: var(--gray-700);
         transition: background-color 0.2s ease;

         &:hover {
            background-color: var(--gray-100);
         }

         &.selected {
            background-color: var(--blue-100);
         }

         i.flag-icon {
            margin-right: 0.75rem;
            width: 24px;
            height: 16px;
         }

         span {
            font-size: var(--normal);
         }
      }
   }
}
</style>
